// 共通スタイル文字列（デザイン言語の一貫性を保つ）
export const card =
  'rounded-2xl border border-line bg-surface shadow-[0_1px_2px_rgba(28,31,51,0.04),0_12px_32px_-20px_rgba(77,85,217,0.25)]'

export const input =
  'w-full rounded-xl border border-line bg-white px-3.5 py-2.5 text-ink outline-none transition focus:border-brand focus:ring-4 focus:ring-brand/15 placeholder:text-muted/60'

export const btnPrimary =
  'inline-flex items-center justify-center rounded-xl bg-brand px-5 py-2.5 font-semibold text-white shadow-[0_8px_24px_-10px_rgba(77,85,217,0.55)] transition hover:bg-brand-ink active:scale-[0.99] disabled:opacity-50'

export const btnGhost =
  'inline-flex items-center justify-center rounded-xl border border-line bg-white px-4 py-2.5 font-medium text-muted transition hover:border-brand/40 hover:text-brand-ink'
